<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="centerImage"><img alt="images" id="img5" src="images/img5.jpg"/></p>
<p class="caption">Members of NIWV District of Columbia Camp No. 5 pose with President Calvin Coolidge on the White House lawn, 1928. Left to right, Evan D. Lewis, A. V. Dummel, G. A. Scheader, Jerome Lawler, Paul Schneider, C.W. Crawford, the President, J. J. Murphy, Henry McDonnell, and C. T. Edwards. <em class="italic">Editor's collection</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_introduction7.vue?6b964148